<template>
  <!--<div style="width: 400px; h_eight: 400px; border: 1px solid skyblue;">-->
  <portlet-container>

      <div slot="header" v-if="show">
        <!--<transition name="bounce">-->
        <button @click="show = !show">Переключить отображение</button>
        <!--</transition>-->
      </div>

    <button @click="show = !show">Переключить отображение</button>
    <p v-for="n in 50" :key="n">a {{n}}</p>
  </portlet-container>
  <!--</div>-->


  <!--
  <div class="portlet-container" :class="portletContainerClass">
    <template  v-if="type == 1">
      <div class="filter-container">
        filter panel
      </div>

      <div class="content-container" style="height: 100%;">
        <h1>Content</h1>
        <p v-for="n in 50" :key="n">a {{n}}</p>
      </div>
    </template>

    <template  v-if="type == 2">
      <div class="content-container" style="height: 100%;">
        <div style="display: flex; flex: auto; flex-direction: column; height: 100%;">

          <div style="height: 100%; overflow: auto; padding: 1rem;">
            asd
            <p v-for="n in 50" :key="n">a {{n}}</p>
          </div>

          <footer class="ui cleared floated footer-container">
            <sui-button class="ui small right floated labeled icon button" icon="plus">Submit</sui-button>
          </footer>

        </div>
      </div>
    </template>

    <template  v-if="type == 3">
      <div class="content-container" style="height: 100%;">
        <div style="display: flex; flex: auto; flex-direction: column; height: 100%;">

          <template  v-if="withHeader">
              <div class="filter-container" style="margin: 0rem;">
                <sui-button class="ui small left floated labeled icon button" icon="plus">Submit</sui-button>
              </div>
          </template>

          <div style="height: 100%; overflow: auto; padding: 1rem;">
            asd
            <p v-for="n in 50" :key="n">a {{n}}</p>
          </div>

          <template  v-if="withFooter">
            <footer class="ui cleared floated footer-container">
              <sui-button class="ui small right floated labeled icon button" icon="plus">Submit</sui-button>
            </footer>
          </template>

        </div>
      </div>
    </template>
  </div>-->
</template>

<script>
// import { Message } from 'element-ui'
import PortletContainer from '@/components/PortletContainer'

export default {
  name: 'HelloWorld',
  // components: {ContentContainer},
  data () {
    return {
      show: true,
      type: 3,
      withHeader: true,
      withFooter: false
    }
  },
  methods: {
  },
  computed: {
    portletContainerClass () {
      return this.type === 2 || this.type === 3 ? 'fixed-filter' : ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .portlet-container {
    padding: 0rem;
  }
  .content-container {
    margin: 0rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/StyleGuide.vue